import { Button } from "@material-ui/core";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { CATEGORY_LIST } from "../../../../constants/categoryList/CategoryList";
import { useState } from "react";

const SortSection = ({ sortField, handleSortChange, setHasClickedSort, handleUpdateCategory, selectedRowMap }: any) => {
	const [category, setCategory] = useState<string>();
	const handleCategoryChange = (event: any) => {
		const { value } = event.target;
		setCategory(value);
	};
	return (
		<div style={{ marginTop: "1.5rem", padding: "1.5rem", display: "flex", justifyContent: "space-between" }}>
			<div>
				<span>
					<FormControl variant="outlined">
						<InputLabel id="demo-simple-select-label">Sort Field</InputLabel>
						<Select
							labelId="demo-simple-select-label"
							id="demo-simple-select"
							name={"field"}
							value={sortField.field}
							label="Sort Field"
							onChange={handleSortChange}
							style={{
								pointerEvents: "unset",
								minWidth: 180,
								textAlign: "left",
								// zIndex: 10000,
								overflowY: "visible",
								marginRight: "1rem",
								marginBottom: "1.5rem"
							}}
							MenuProps={{
								style: { zIndex: 35960 }
							}}
							inputProps={{ "aria-label": "Without label" }}
						>
							<MenuItem value="" disabled>
								Select Value
							</MenuItem>
							<MenuItem value={"claim_number"}>Claim Number</MenuItem>
							<MenuItem value={"patient_first_name"}>First Name</MenuItem>
							<MenuItem value={"patient_last_name"}>Last Name</MenuItem>
							<MenuItem value={"date_of_service"}>DOS</MenuItem>
							<MenuItem value={"closure_ltr_date"}>Date to Send Closure Ltr</MenuItem>
							<MenuItem value={"closure_sent_date"}>Closure Sent Date</MenuItem>
							<MenuItem value={"payee"}>Payee</MenuItem>
							<MenuItem value={"total_charge"}>Total Charge</MenuItem>
							<MenuItem value={"discount"}>Discount</MenuItem>
							<MenuItem value={"savings"}>Savings</MenuItem>
							<MenuItem value={"allowable"}>Allowable</MenuItem>
							<MenuItem value={"copay"}>Co-Pay</MenuItem>
							<MenuItem value={"paid"}>Paid</MenuItem>
							<MenuItem value={"TPA_fee"}>Nex Fees</MenuItem>
							<MenuItem value={"other_fee"}>Other Fees</MenuItem>
							<MenuItem value={"net_savings"}>Net Savings</MenuItem>
							<MenuItem value={"percentage_savings"}>Percentage Savings</MenuItem>
							<MenuItem value={"cheque_number"}>Check Number</MenuItem>
							<MenuItem value={"agreement_sent"}>Agreement Number</MenuItem>
							<MenuItem value={"cheque_mailed"}>Check Mailed</MenuItem>
							<MenuItem value={"cheque_received"}>Check Received</MenuItem>
							<MenuItem value={"cheque_cleared"}>Check Cleared</MenuItem>
							<MenuItem value={"reissued"}>Reissued</MenuItem>
						</Select>
					</FormControl>
				</span>
				<span>
					<FormControl variant="outlined">
						<InputLabel id="demo-simple-select-label" variant="outlined">
							Sort Order
						</InputLabel>
						<Select
							labelId="demo-simple-select-label"
							id="demo-simple-select-helper"
							name={"order"}
							label="Sort Order"
							value={sortField.order}
							onChange={handleSortChange}
							style={{
								pointerEvents: "unset",
								minWidth: 180,
								textAlign: "left",
								// zIndex: 10000,
								overflowY: "visible",
								marginRight: "1rem",
								marginBottom: "1rem"
							}}
							MenuProps={{
								style: { zIndex: 35960 }
							}}
							inputProps={{ "aria-label": "Without label" }}
						>
							<MenuItem value="" disabled>
								Select Value
							</MenuItem>
							<MenuItem value={"asc"}>Ascending</MenuItem>
							<MenuItem value={"desc"}>Decending</MenuItem>
						</Select>
					</FormControl>
				</span>
				<span>
					<Button className="button-container" onClick={() => setHasClickedSort(true)} variant="contained">
						Sort
					</Button>
				</span>
			</div>
			{selectedRowMap.size > 0 ? (
				<div>
					<FormControl variant="standard">
						<InputLabel id="demo-simple-select-helper-label">Change Category</InputLabel>
						<Select
							labelId="demo-simple-select-helper-label"
							id="demo-simple-select-helper"
							name={"order"}
							label="Change Category"
							value={category}
							onChange={handleCategoryChange}
							style={{
								pointerEvents: "unset",
								minWidth: 180,
								textAlign: "left",
								// zIndex: 10000,
								overflowY: "visible",
								marginRight: "1rem",
								marginBottom: "1rem"
							}}
							MenuProps={{
								style: { zIndex: 35960 }
							}}
							inputProps={{ "aria-label": "Without label" }}
						>
							<MenuItem value="" disabled>
								Select Value
							</MenuItem>
							<MenuItem value={"is_all_claims"}>{CATEGORY_LIST.is_all_claims}</MenuItem>
							<MenuItem value={"is_check_status_requested"}>
								{CATEGORY_LIST.is_check_status_requested}
							</MenuItem>
							<MenuItem value={"is_closure_letter_required"}>
								{CATEGORY_LIST.is_closure_letter_required}
							</MenuItem>
							<MenuItem value={"is_closure_letter_completed"}>
								{CATEGORY_LIST.is_closure_letter_completed}
							</MenuItem>
						</Select>
					</FormControl>
					<span>
						<Button
							className="button-container"
							onClick={() => handleUpdateCategory(category)}
							variant="contained"
						>
							Update Category
						</Button>
					</span>
				</div>
			) : null}
		</div>
	);
};

export default SortSection;
